/* global __CARTO_BASEMAP_KEY__ */

const BASE_URL = process.env.API_URL;
const CARTO_BASEMAP_KEY =
  typeof __CARTO_BASEMAP_KEY__ === 'undefined' ? '' : __CARTO_BASEMAP_KEY__;

export default {
  BASE_URL,
  API_URL: `${BASE_URL}/api/v1`,
  CARTO_BASEMAP_KEY,
  GOOGLE_KEY: 'AIzaSyAQge6X2vwxf-QDJmuuWqu3hdpUrJagOPw',
  GOOGLE_RECHAPTCHA_V3: '6LcCLqYZAAAAAI_xNIfmLa0m50Kqop_lft98kTiz',
  GA: 'UA-168020682-1',
  SENTRY_DNS:
    process.env.NODE_ENV === 'production'
      ? 'https://eba8e633f6d0492fb2c5922c737c9967@o429115.ingest.sentry.io/5556031'
      : null,
};
